import { Field } from 'Util/Query';

/**
 * Email availability check Query
 * @class CheckEmailQuery
 * @namespace Query/CheckEmail
 */
export class CheckEmailQuery {
    getIsEmailAvailableQuery(email) {
        const query = new Field('isEmailAvailable')
            .addArgument('email', 'String!', email)
            .addField('is_email_available');

        return query;
    }
}

export default new CheckEmailQuery();
